import { isHebrew } from "../utils/headline";

// ─── A headline, in Hebrew or not at all (26/10/2026) ────────────────────────
// The app shows no English headline. An article without its Hebrew headline
// is held back by the list that shows it (utils/headline.js, useHebrewNews)
// until the server has translated it; this is the last guard, so a headline
// that slips through still never reaches the screen in English.
//
// `source`: the reader chose the source language (the news screen in English
// mode) · the original is then the headline, in an LTR isolate.
export default function Headline({ text, style, source = false }) {
  if (!text) return null;
  const he = isHebrew(text);
  if (!he && !source) return null;
  return (
    <div
      dir={he ? "rtl" : "ltr"}
      style={{ ...style, ...(he ? null : { unicodeBidi: "isolate", textAlign: "start" }) }}
    >
      {text}
    </div>
  );
}
